import { IonImg } from '@ionic/react';
import { MouseEventHandler, PropsWithChildren, useEffect } from 'react';

import { useActiveSessionStore } from '@/hooks/useActiveSessionStore';
import { useSensors } from '@/hooks/useSensors';

import { useSensorsContext } from '@/contexts/SensorsContext';

import ErrorIllustration from '@/assets/illustrations/ErrorIllustration.svg';

import styles from './NoInternet.module.css';

import { Button, ButtonProps } from '../Button';

type ButtonWithChildrenProps = PropsWithChildren<ButtonProps>;

interface NoInternetProps {
  title?: string;
  description?: string;
}

export const NoInternet = ({
  title = 'Offline Mode',
  description = 'You are currently offline. We could not load your data.',
}: NoInternetProps) => {
  return (
    <div className={styles.container}>
      <IonImg
        alt='Stylized cross made of six red dots in a curved, upward motion, centered within a large off-white circle.'
        className={styles.illustration}
        src={ErrorIllustration}
      />
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>

      {/* <div className={styles.buttons}>
        <div className={styles.topButtons}>
          <Button
            className={styles.button}
            variant='secondary'
            {...endSessionButton}
            onClick={(event) => wrappedOnComplete(event, endSessionButton?.onClick)}
          >
            {endSessionButton?.children ?? 'End session'}
          </Button>

          <Button
            className={styles.button}
            disabled
            variant='primary'
            {...newRecordingButton}
            onClick={(event) => wrappedOnComplete(event, newRecordingButton?.onClick)}
          >
            {newRecordingButton?.children ?? 'New recording'}
          </Button>
        </div>

        <div className={styles.divider}>
          <hr />
          <span>OR</span>
          <hr />
        </div>

        <Button
          className={styles.button}
          variant='secondary'
          {...reconfigureSensorsButton}
          onClick={(event) => wrappedOnComplete(event)}
        >
          {reconfigureSensorsButton?.children ?? 'Re-Configure Sensors'}
        </Button>
      </div> */}
    </div>
  );
};
